import { useConfigService } from '@thd-nucleus/experience-context';
import { getUpdatedProducts } from '../utils/product-utils';
import { useDataProducts } from './useDataProducts';

export const useBundleProducts = ({ bundle }) => {
  const bundleComponents = bundle?.bundleSpecificationDetails?.components;
  const configBundleProductsDetails = useConfigService('bundleProductsDetails') || null;
  const configBundleProductsKitchen = useConfigService('bundleProductsKitchen') || null;
  const bundleProductsKitchen = configBundleProductsKitchen ? configBundleProductsKitchen.split(',') : null;
  const { data, loading, error } = useDataProducts({
    itemIds: bundleProductsKitchen || bundleComponents?.map(({ defaultProductId }) => defaultProductId),
    skip: !bundleComponents || bundleComponents.length === 0
  });

  return {
    productsData: getUpdatedProducts(data?.products, bundleComponents, configBundleProductsDetails),
    error,
    loading
  };
};
